var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('div',{staticClass:"system"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v("页面走丢了...")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.list.content))]),_vm._v(" "),_c('h4',[_vm._v("请仔细检查您输入的网址是否正确。")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7893cb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lost_page.vue
// module id = null
// module chunks = 